export const PROJECT_INIT = 'PROJECT_INIT';
export const PROJECT_FAIL = 'PROJECT_FAIL';
export const FETCH_PROJECTS = 'FETCH_PROJECTS';
export const FETCH_ONE_PROJECT = 'FETCH_ONE_PROJECT';
export const SELECT_PROJECT = 'SELECT_PROJECT';